import './polyfills'
import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { Global, ThemeProvider } from '@emotion/react'
import { getTheme } from '@yuno/sdk-web-core/dist/theme/theme'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { resetCss } from './styles'
import { QueryProvider } from './state'
import './i18n'
import { loadScript } from '@yuno-payments/sdk-web'
import { getGeolocationIfEnabled } from './utils/geolocation'
import { useTranslation } from 'react-i18next'

const RTLWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { i18n } = useTranslation()
  return <div dir={i18n.dir()}>{children}</div>
}
loadScript({
  env: process.env.REACT_APP_SDK_WEB_ENV as any || 'prod',
})

console.log('checkout-version: ', process.env.REACT_APP_VERSION)

const theme = getTheme()

const App = () => {
  return (
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <Global styles={[resetCss]} />
        <QueryProvider>
          <RTLWrapper>
            <RouterProvider router={router} />
          </RTLWrapper>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryProvider>
      </ThemeProvider>
    </React.StrictMode>
  )
}

getGeolocationIfEnabled().then((position) => {
  if (position) {
    console.log('position', position)
  }
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)

reportWebVitals()
